import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable, Subject } from 'rxjs';
import {
  BaseAuthenticatedService,
  httpQueryParams,
  PaginatedResponse,
  RecursiveInterface,
} from './base-authenticated.service';
import { DocumentsInterface } from '@app/interface/documents';

@Injectable({
  providedIn: 'root',
})
export class DocumentsApiService extends BaseAuthenticatedService {
  constructor(
    public override auth: AngularFireAuth,
    public override httpClient: HttpClient // private cookieService: CookieService
  ) {
    super(auth, httpClient);
  }

  // using getRecursivePage
  public getAllDocuments<T = DocumentsInterface>(
    organization_id: number | null,
    params: httpQueryParams = {}
  ): Subject<RecursiveInterface<T>> {
    const path = `api/${organization_id}/document/`;
    return this.getRecursivePage<T>(path, params);
  }

  public uploadDocument(
    organization_id: number,
    formData: FormData
  ): Observable<DocumentsInterface> {
    const path = `api/${organization_id}/document/`;
    return this.create<DocumentsInterface>(path, {}, formData);
  }
}
